export class MarginInfoItem {
}
